import { useState } from 'react';

function CoreJavaModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Java",
      content: [
        "What is Java?",
        "History of Java and its importance",
        "Java Development Kit (JDK) vs Java Runtime Environment (JRE)",
        "Setting up Java Development Environment (IDE, JDK)",
        "Hello World Program in Java",
        "Structure of a Java Program",
        "Java Compilation and Execution Process"
      ]
    },
    {
      title: "Module 2: Data Types and Variables",
      content: [
        "Primitive Data Types: int, float, double, char, boolean",
        "Reference Data Types: String, Arrays, Objects",
        "Variables in Java: Declaration and Initialization",
        "Constants and final keyword",
        "Type Casting: Implicit and Explicit",
        "Wrapper Classes in Java (Integer, Double, etc.)"
      ]
    },
    {
      title: "Module 3: Control Flow Statements",
      content: [
        "If-else Statements",
        "Switch-case Statements",
        "Ternary Operator",
        "Loops in Java: for, while, do-while",
        "Break and Continue Statements",
        "Nested Loops"
      ]
    },
    {
      title: "Module 4: Functions and Methods",
      content: [
        "Defining Methods in Java",
        "Method Overloading",
        "Method Parameters and Return Type",
        "Recursion in Java",
        "Varargs (Variable Arguments)",
        "Java Lambda Expressions"
      ]
    },
    {
      title: "Module 5: Object-Oriented Programming (OOP)",
      content: [
        "Introduction to OOP Concepts",
        "Classes and Objects",
        "Constructor in Java",
        "Encapsulation: Access Modifiers (private, public, protected, default)",
        "Inheritance and Types: Single, Multilevel, Hierarchical",
        "Polymorphism: Method Overriding and Method Overloading",
        "Abstraction and Interfaces",
        "Java Abstract Classes vs Interfaces",
        "Java Packages and Importing"
      ]
    },
    {
      title: "Module 6: Arrays and Collections",
      content: [
        "Arrays: Declaring, Initializing, and Accessing Elements",
        "Multidimensional Arrays",
        "ArrayList: Creating, Adding, and Removing Elements",
        "Other Collection Types: LinkedList, HashSet, TreeSet, HashMap",
        "Iterator and ListIterator in Java",
        "Sorting and Searching in Collections",
        "Generics in Java"
      ]
    },
    {
      title: "Module 7: Exception Handling",
      content: [
        "What are Exceptions?",
        "Types of Exceptions: Checked vs Unchecked",
        "Try-catch-finally Block",
        "Throw and Throws Keyword",
        "Custom Exceptions in Java",
        "Handling Multiple Exceptions"
      ]
    },
    {
      title: "Module 8: File Handling in Java",
      content: [
        "Introduction to File Handling",
        "Reading and Writing Files in Java (FileReader, FileWriter)",
        "BufferedReader and BufferedWriter",
        "File I/O with Streams (InputStream, OutputStream)",
        "Serialization and Deserialization in Java",
        "Handling Directories and Files with NIO (New I/O)"
      ]
    },
    {
      title: "Module 9: Multithreading in Java",
      content: [
        "Introduction to Multithreading",
        "Creating Threads: Extending Thread Class, Implementing Runnable Interface",
        "Thread Lifecycle: new, runnable, running, waiting, terminated",
        "Thread Synchronization",
        "Inter-thread Communication",
        "Thread Pool and Executor Framework"
      ]
    },
    {
      title: "Module 10: Java 8 Features",
      content: [
        "Lambda Expressions",
        "Streams API: Creating, Filtering, and Collecting Data",
        "Default Methods and Static Methods in Interfaces",
        "Method References",
        "Optional Class",
        "Functional Interfaces"
      ]
    },
    {
      title: "Module 11: Java Database Connectivity (JDBC)",
      content: [
        "What is JDBC?",
        "JDBC Architecture and Drivers",
        "Connecting to a Database using JDBC",
        "Executing SQL Queries with Statement and PreparedStatement",
        "ResultSet: Fetching Data from Database",
        "Transactions in JDBC",
        "Handling Exceptions in JDBC"
      ]
    },
    {
      title: "Module 12: Java Development Tools",
      content: [
        "Introduction to Integrated Development Environments (IDEs)",
        "Using Eclipse/IntelliJ IDEA for Java Development",
        "JUnit for Unit Testing in Java",
        "Maven for Project Management and Dependency Handling",
        "Debugging Techniques in Java",
        "Building Java Projects and Packaging as JAR files"
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Core Java Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CoreJavaModule;
